// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1LOhg","header":"Messages_header__1hPrC"};